export class CafeAudio {
  private context: AudioContext | null = null;
  private allowedThisVisit = false;
  private activationArmed = false;
  private volume = 0.55;
  private muted = false;

  constructor() {
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) void this.context?.suspend();
      else if (this.allowedThisVisit && !this.muted) void this.context?.resume();
    });
  }

  get enabled(): boolean { return this.allowedThisVisit; }
  get isMuted(): boolean { return this.muted; }

  applyPreference(preferred: boolean, volume: number): void {
    this.volume = Math.max(0, Math.min(1, volume));
    this.allowedThisVisit = preferred;
    this.muted = false;
    if (!preferred) { void this.context?.suspend(); return; }
    if (this.context) { void this.context.resume(); return; }
    this.armActivation();
  }

  private armActivation(): void {
    if (this.activationArmed) return;
    this.activationArmed = true;
    const activate = () => {
      document.removeEventListener('pointerdown', activate, true);
      document.removeEventListener('keydown', activate, true);
      this.activationArmed = false;
      if (!this.allowedThisVisit || this.muted || this.context) return;
      try {
        this.context = new AudioContext();
        void this.context.resume();
      } catch { this.allowedThisVisit = false; }
    };
    document.addEventListener('pointerdown', activate, true);
    document.addEventListener('keydown', activate, true);
  }

  async enable(volume: number): Promise<boolean> {
    this.volume = volume;
    try {
      this.context ??= new AudioContext();
      await this.context.resume();
      this.allowedThisVisit = true;
      this.muted = false;
      this.play('cat');
      return true;
    } catch { return false; }
  }

  setVolume(volume: number): void { this.volume = Math.max(0, Math.min(1, volume)); }
  toggleMute(): boolean { this.muted = !this.muted; if (this.muted) void this.context?.suspend(); else if (this.allowedThisVisit) { if (this.context) void this.context.resume(); else this.armActivation(); } return this.muted; }

  play(kind: 'serve' | 'cat' | 'reward'): void {
    if (!this.allowedThisVisit || this.muted || !this.context) return;
    const ctx = this.context;
    const notes = kind === 'serve' ? [523, 659] : kind === 'reward' ? [523, 659, 784, 1047] : [440, 523];
    const start = ctx.currentTime;
    notes.forEach((frequency, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = kind === 'cat' ? 'sine' : 'triangle';
      osc.frequency.value = frequency;
      gain.gain.setValueAtTime(0.0001, start + i * 0.08);
      gain.gain.exponentialRampToValueAtTime(Math.max(0.001, this.volume * 0.11), start + i * 0.08 + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + i * 0.08 + 0.18);
      osc.connect(gain).connect(ctx.destination);
      osc.start(start + i * 0.08);
      osc.stop(start + i * 0.08 + 0.2);
    });
  }
}
